import React from 'react'

import OrangeIcon from 'src/components/Icon/OrangeDsIcon'

import Error from './assets/error.png'
import Success from './assets/success.png'
import {
  ModalOverlay,
  ModalContent,
  ModalIcon,
  ModalTitle,
  ModalDescription,
  ModalButton,
  ModalCloseButton,
} from './style'

type StatusType = 'success' | 'error'

interface StatusModalProps {
  open: boolean
  type: StatusType
  onClose: () => void
}

const MODAL_CONFIG: Record<
  StatusType,
  { icon: string; title: string; description: string; buttonText: string }
> = {
  success: {
    icon: Success,
    title: 'Cadastro realizado com sucesso!',
    description:
      'Agora é só aguardar para receber os melhores conteúdos de especialistas em investimento no seu e-mail.',
    buttonText: 'Conheça o nosso portal',
  },
  error: {
    icon: Error,
    title: 'Cadastro não realizado',
    description: 'Por favor, tente novamente mais tarde.',
    buttonText: 'Tentar novamente',
  },
}

const StatusModal = ({ open, type, onClose }: StatusModalProps) => {
  if (!open) return null

  const { icon, title, description, buttonText } = MODAL_CONFIG[type]

  const handleOverlayClick = (event: React.MouseEvent<HTMLDivElement>) => {
    if (event.target === event.currentTarget) {
      onClose()
    }
  }

  const handleButtonClick = () => {
    onClose()
    if (type === 'success') {
      window.location.href = '/'
    }
  }

  return (
    <ModalOverlay onClick={handleOverlayClick} role="dialog" aria-modal="true">
      <ModalContent>
        <ModalCloseButton type="button" onClick={onClose} aria-label="Fechar" title="Fechar">
          <OrangeIcon icon="exit" size="LG" color="#FF7A00" />
        </ModalCloseButton>
        <ModalIcon src={icon} alt={title} />
        <ModalTitle>{title}</ModalTitle>
        <ModalDescription>{description}</ModalDescription>
        <ModalButton type="button" onClick={handleButtonClick} title={buttonText}>
          {buttonText}
        </ModalButton>
      </ModalContent>
    </ModalOverlay>
  )
}

export default StatusModal
